//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : Agregado de talle en prenda

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import Notify from "../../Notify";
import { postData } from "../../../services/library";

function AgregarTalle(props) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [disabled, setDisabled] = useState(false);
  const [datosTalle, setDatosTalle] = useState({
    talle:"",
    descripcion:""
  });
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const almacenar = (e) => {
    setDatosTalle({
      ...datosTalle,
      [e.target.name]: e.target.value,
    });
  };
  // console.log(datosTalle);
  
    const guardarTalle = (e) => {
      setDisabled(true);
      postData(
        e,
        "/stock_prendas_talles",
        {
          id_tipo:props.prenda.id,
          talle:datosTalle.talle,
          descripcion:datosTalle.descripcion,
          estado: 1
        },
        setNotificacion
      );
    };

  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            props.setOpen(false);
          }}
          severity={notificacion.severity}
        />
      ) : null}
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.setOpen(false)}
        maxWidth="lg"
        // position="absolute"
        // sx={{ zIndex: "1000" }}
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Agregar talle en {props.prenda.nombre}
            </Typography>
          </DialogTitle>
        </Box>
        <form 
        onSubmit={guardarTalle}
        >
          <Box
            // border={0.5}
            // borderColor={grey[300]}
            // backgroundColor="#F4F6F6"
            p={2}
            py={2}
          >
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    label="Talle"
                    size="small"
                    name="talle"
                    value={datosTalle.talle}
                    onChange={almacenar}
                    focused
                    fullWidth
                    required
                    style={style}
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    label="Descripcion"
                    size="small"
                    name="descripcion"
                    value={datosTalle.descripcion}
                    onChange={almacenar}
                    focused
                    style={style}
                    required
                  />
                </Grid>
              </Grid>
              <Grid
                mt={1}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button
                  // disabled={disBtn}
                  variant="contained"
                  onClick={() => props.setOpen(false)}
                  color="error"
                >
                  Volver
                </Button>
                <Button
                  disabled={disabled}
                  variant="contained"
                  // onClick={guardarEmpleados}
                  type="submit"
                  color="success"
                >
                  Guardar
                </Button>
              </Grid>
            </DialogContent>
          </Box>
        </form>
      </Dialog>
    </div>
  );
}

export default AgregarTalle;
